import React, { ReactElement, useState } from 'react';
import { AccountResponse } from '../structures/response/AccountResponse';
import AccountContext from './AccountContext';

export default function AccountProvider({
  children,
}: {
  children: ReactElement;
}) {
  const [accountResponse, setAccountResponse] =
    useState<AccountResponse | null>(null);

  const value = React.useMemo(
    () => ({
      accountResponse,
      setAccountResponse,
    }),
    [accountResponse]
  );

  return (
    <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
  );
}
